import React, { useState } from 'react';
import { Button } from './button';
import { Input } from './input';

import { saveAddress, getCurrentLocation } from '../../services/addresses';
export const AddressForm = ({ phoneNumber, onAddressSaved, customerId }) => {

  const [formData, setFormData] = useState({
    phone_number: '',
    full_name: '',
    address_1: '',
    address_2: '',
    pincode: '',
    city: '',
    landmark: '',
    state: '',
  });
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveAddress = async () => {
    const coordinates = await getCurrentLocation();
    const addressData = {
      ...formData,
      phoneNumber: `+91${phoneNumber}`,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude
    };
  
    saveAddress(customerId, addressData)
      .then(data => {})
      .catch(err => {})
    if (onAddressSaved) {
      onAddressSaved();
      setFormData({
        phone_number: '',
        full_name: '',
        address_1: '',
        address_2: '',
        pincode: '',
        city: '',
        landmark: '',
        state: '',
      });
    }
    
  };

  return (
    <div className="mt-4 space-y-2">
      <Input
        placeholder="Full name"
        value={formData.full_name}
        onChange={(e) => handleInputChange('full_name', e.target.value)}
      />
      <Input
        placeholder="House No., street"
        value={formData.address_1}
        onChange={(e) => handleInputChange('address_1', e.target.value)}
      />
      <Input
        placeholder="Area, locality"
        value={formData.address_2}
        onChange={(e) => handleInputChange('address_2', e.target.value)}
      />
      <Input
        placeholder="Pincode"
        value={formData.pincode}
        onChange={(e) => handleInputChange('pincode', e.target.value)}
      />
      <Input
        placeholder="City"
        value={formData.city}
        onChange={(e) => handleInputChange('city', e.target.value)}
      />
      <Input
        placeholder="Landmark"
        value={formData.landmark}
        onChange={(e) => handleInputChange('landmark', e.target.value)}
      />
      <Input
        placeholder="State"
        value={formData.state}
        onChange={(e) => handleInputChange('state', e.target.value)}
      />
      <Button onClick={handleSaveAddress} className="w-full">
        Save Address
      </Button>
    </div>
  );
};
